import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { whatsappOptIn, whatsAppStatusCheck } from '../api/yellow-messenger.api';

interface yellowMessengerOutput {
  from: string;
  to: string;
  message: {
    code: string;
    data: {
      number: string;
      name: string;
      param_1: string;
      param_2: string;
      param_3: string;
      param_4: string;
      param_5: string;
      param_6: string;
      param_7: string;
      param_8: string;
      param_9: string;
      param_10: string;
      tags: string[];
    };
  };
}

const initialData = {
  from: '',
  to: '',
  message: {
    code: '',
    data: {
      number: '',
      name: '',
      param_1: '',
      param_2: '',
      param_3: '',
      param_4: '',
      param_5: '',
      param_6: '',
      param_7: '',
      param_8: '',
      param_9: '',
      param_10: '',
      tags: ['', '', ''],
    },
  },
};

interface whatsappDataState {
  messengerDate: yellowMessengerOutput;
  loading: boolean;
  error: string;
  isEnrolled: boolean;
}

// Define the initial state using that type
const initialState: whatsappDataState = {
  messengerDate: initialData,
  loading: false,
  error: '',
  isEnrolled: false
};

interface ReqPayload {
  mobile: string;
}

interface StatusPayload {
  searchColumn: string,
  searchValue: string | null
}

export const whatsApi = createAsyncThunk(
  'whatsapp/SavePhoneno',
  async (payload: ReqPayload, thunkApi) => {
    return whatsappOptIn(payload)
      .then((response: yellowMessengerOutput) => {
        return response;
      })
      .catch((error: { response: { data: unknown } }) => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const checkWhatsappStatus = createAsyncThunk(
  'whatsapp/checkStatus',
  async (payload: StatusPayload, thunkApi) => {
    return whatsAppStatusCheck(payload).then((response: any) => {
      const { data } = response;
      return !!(data.docs.length > 0 && data.docs.some((elem: any) => elem?.tags.includes('OPTIN')));
    }).catch((error: { response: { data: unknown } }) => {
      return thunkApi.rejectWithValue(error.response.data);
    })
  }
)

export const yellowMessengerSlice = createSlice({
  name: 'whatsappData',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(whatsApi.pending, state => {
      state.loading = true;
    });
    builder.addCase(whatsApi.fulfilled, (state, action) => {
      state.loading = false;
      state.messengerDate = action.payload;
    });
    builder.addCase(whatsApi.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
    builder.addCase(checkWhatsappStatus.pending, state => {
      state.loading = true;
    });
    builder.addCase(checkWhatsappStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.isEnrolled = action.payload;
    });
    builder.addCase(checkWhatsappStatus.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const whatsappData = (state: RootState): yellowMessengerOutput =>
  state.yellowMessengerReducer.messengerDate;
export const errorinwhatsapp = (state: RootState): string =>
  state.yellowMessengerReducer.error;
export const whatsappDataLoadind = (state: RootState): boolean =>
  state.yellowMessengerReducer.loading;
export const whatsAppEnrolledStatus = (state: RootState): boolean => state.yellowMessengerReducer.isEnrolled;

export default yellowMessengerSlice.reducer;
